module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nb-NO":{"error_text":"Noe gikk galt.. <br> Vennligst prøve og last siden på nytt ved å trykke <a href=\u0027\u0027>her</a>"}}')
  delete Component.options._Ctor
}
